<ng-container *ngIf="viewModel$ | async as viewModel">
  <section class="customer">
    <div class="shared-section">
      <div
        *ngIf="viewModel.jobNotInCurrentZone"
        class="shared-job-overlay"
      ></div>
      <app-overview-header></app-overview-header>
    </div>

    <div class="shared-section">
      <div
        *ngIf="viewModel.jobNotInCurrentZone"
        class="shared-job-overlay"
      ></div>
      <app-overview-customer></app-overview-customer>
    </div>

    <app-overview-summary
      summaryKey="adminSummary"
      header="Admin Summary"
      class="p-mt-4"
    ></app-overview-summary>

    <section
      class="ops-notes-display p-mt-3"
    >
      <header>
        <div class="content">
          <!-- Ray: the Overview's Ops Summary should be editable (#6983).
               Job-level (one per job — the same calculatorOutput__opsNotes the
               Dispatch mini-cards write); saves on blur. The label[for] keeps
               the field's accessible name once the placeholder disappears
               (CodeRabbit). Styled like the Admin Summary card above — same
               header (no uppercase/letter-spacing/icon, no hint) and the
               standard PrimeNG textarea instead of hand-rolled styles
               ( CodeRabbit round 8 ). -->
          <label class="value" for="ops-summary-input">Ops Summary</label>
        </div>
      </header>
      <hr />
      <!-- Render only once the job id exists: the route resolves before the
           job fetch, and a '' draft key would lose the typed text when the
           real job loads (CodeRabbit). Outside-zone jobs stay read-only,
           like the other editing sections. -->
      <textarea
        *ngIf="viewModel.job?.id as jobId"
        id="ops-summary-input"
        pInputTextarea
        class="ops-notes-display__input"
        [ngModel]="getOpsNotesDraft(jobId, viewModel.opsNotes ?? '')"
        (ngModelChange)="onOpsNotesInput(jobId, $event)"
        (blur)="onOpsNotesBlur(viewModel.job, viewModel.opsNotes ?? '')"
        [disabled]="opsNotesSaving || viewModel.jobNotInCurrentZone"
        [placeholder]="'Add an Ops Summary for this job…'"
        rows="3"
      ></textarea>
    </section>

    <div class="shared-section">
      <div
        *ngIf="viewModel.jobNotInCurrentZone"
        class="shared-job-overlay"
      ></div>
      <app-overview-ops-tasks></app-overview-ops-tasks>
    </div>

    <section
      *ngIf="viewModel.heartbeatEnabled && viewModel.heartbeatSummary"
      class="heartbeat-summary p-mt-3"
    >
      <header class="heartbeat-summary__header">
        <i class="pi pi-android"></i>
        <span>AI Summary</span>
        <span *ngIf="viewModel.heartbeatLastRan" class="heartbeat-summary__time">
          {{ dayjs.unix(viewModel.heartbeatLastRan).fromNow() }}
        </span>
      </header>
      <div class="heartbeat-summary__body" markdown [data]="viewModel.heartbeatSummary"></div>
    </section>

    <div class="shared-section">
      <div
        *ngIf="viewModel.jobNotInCurrentZone"
        class="shared-job-overlay"
      ></div>
      <app-overview-timeline></app-overview-timeline>
    </div>

    <app-overview-locations></app-overview-locations>
  </section>
</ng-container>
